import { Injectable } from '@angular/core';
import {
    DateRange,
    MatDateRangeSelectionStrategy
} from '@angular/material/datepicker';
import { HOURS, MILLISECONDS, MINUTES, SECONDS } from '@nagel-utils';
import { DATE_RANGE_LIMIT } from '@nagel-consts';
import { DateTimeRangeService } from '@nagel-services';

@Injectable()
export class CustomDateSelectionStrategy<D> implements MatDateRangeSelectionStrategy<D> {
    constructor(private headerFiltersService: DateTimeRangeService) {}

    selectionFinished = (date: D | null, currentRange: DateRange<D>): DateRange<D> => {
        let { start, end } = currentRange;

        if (start == null) {
            start = date;
        }
        else if (end == null && date && date > start) {
            end = date;
        }
        else {
            start = date;
            end = null;
        }

        if (start && end) {
            const startDate = new Date(start as unknown as string);
            const endDate = new Date(end as unknown as string);
            const diffTime = Math.abs(endDate.getTime() - startDate.getTime());
            const diffDays = Math.ceil(diffTime / (MILLISECONDS * SECONDS * MINUTES * HOURS));

            if (diffDays >= DATE_RANGE_LIMIT) {
                this.headerFiltersService.setErrors({ dateRangeExceedsLimit: true });
            } else {
                this.headerFiltersService.setErrors(null);
            }
        }
        return new DateRange(start, end);
    };

    createPreview(activeDate: D | null, currentRange: DateRange<D>): DateRange<D> {
        const { start } = currentRange;
        return start && activeDate ? new DateRange<D>(start, activeDate) : new DateRange<D>(null, null);
    }
}